import React from "react";
import Sidebar from "../components/Sidebar";

const Zeni = () => {
    return (
        <div className="content">
            <Sidebar />
            <div className='main-content'>
            <h1>Zeni</h1>
            <p>Welcome to the Zeni page!</p>
            <p>Here you can find information about the Zeni currency.</p>
            <div className="zeni-info">
                <h2>What is Zeni?</h2>
                <p>Zeni is a virtual currency used within the ISN Network. It can be bought on our store website and used to purchase items and services on the platform.</p>
                <h2>How to Earn Zeni</h2>
                <p>Zeni can currently not be earned through any in-game activities. It can only be obtained through purchases or special promotions.</p>
                <h2>How to Use Zeni</h2>
                <p>Zeni can be used to purchase items in the ISN Network in-game store, access premium features, and more.</p>
                <h2>Frequently Asked Questions</h2>
                <div className="faq-item">
                    <h3>How do I check my Zeni balance?</h3>
                    <p>You can check your Zeni balance in-game by running the command `/zeni`.</p>
                </div>
                <div className="faq-item">
                    <h3>Can I transfer Zeni to other users?</h3>
                    <p>No, you can't transfer Zeni to other users within the ISN Network.</p>
                </div>
                <div className="faq-item">
                    <h3>Is Zeni refundable?</h3>
                    <p>No, Zeni is non-refundable and cannot be exchanged for real currency.</p>
                </div>
                <div className="faq-item">
                    <h3>I created a new in-game account, but my old one has Zeni on it.</h3>
                    <p>If you are unable to access your old in-game account which contains Zeni, please contact our support team for assistance.</p>
                </div>
            </div>
            </div>
        </div>
    );
}
export default Zeni;